import "Layouts/default"

import 'Ui/slider';

import 'Common/social';
import 'Common/lightgallery';

import { checkResolution } from "Functions/helpers";

import './articles-jquery'
import { scrollToEl } from "Functions/anchor";
import { updateLazy } from "Functions/lazy";

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll('.pager__list .c-btn')) {
        if (pagerButton.classList.contains('is-active')) continue
        if (pagerButton.classList.contains('is-disabled')) continue

        pagerButton.addEventListener('click', (event) => {
            scrollToEl(document.querySelector('.l-catalog-products') || document.querySelector('.listing'), (checkResolution('cxs;xs') ? 0 : 40))
        })
    }
}

attachPaginatorEvents()

Event.on('Listing.fetchedData', () => {
    attachPaginatorEvents()
    updateLazy()
})

const initNavScrollLeft = () => {
    if (!document.querySelector('.js-articles-nav .is-selected')) return

    const nav = document.querySelector('.js-articles-nav')
    const selectedItem = nav.querySelector('.is-selected')
    const containerPadding = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--container-padding')) || 20
    const maxScrollLeft = nav.scrollWidth - nav.offsetWidth

    if (selectedItem.offsetLeft + selectedItem.offsetWidth + containerPadding > nav.offsetWidth) {
        let initialNavScrollLeft = Math.round(selectedItem.offsetLeft - nav.offsetWidth + (selectedItem.offsetWidth / 2) + (nav.offsetWidth / 2))

        if (initialNavScrollLeft > maxScrollLeft) {
            initialNavScrollLeft = maxScrollLeft
        }

        nav.scroll({
            left: initialNavScrollLeft,
            behavior: 'smooth'
        })
    }
}

if (checkResolution('cxs;xs')) {
    initNavScrollLeft()
}

const imageVideo = document.querySelector('.js-article-image-video')

if (imageVideo) {
    imageVideo.addEventListener('click', (event) => {
        const button = event.currentTarget
        const iframeEl = document.createElement('iframe')

        iframeEl.setAttribute('autoplay', 1)
        iframeEl.setAttribute('allowfullscreen', 1)
        iframeEl.setAttribute('frameborder', 0)
        iframeEl.setAttribute('src', button.dataset.src)
        iframeEl.classList.add('is-video')
        iframeEl.classList.add('is-active')

        button.parentNode.appendChild(iframeEl)
    })
}